import { UpdateSectionPositions } from '../../lib/types/models/language-test/language-test-section'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const updateSectionPositions = ({ id, ...rest }: UpdateInput<UpdateSectionPositions>) =>
  restApiClient
    .url(constructApiUrl(API.languageTest.updateSectionPositions.url, { templateId: id }))
    .put<UpdateSectionPositions>(rest)
